import * as colors from "./colors";
import "./fonts.css";
import { calcEmFromPx } from "./utils";

/** Themes */
export const default_theme = {
  /* Typography  */
  font_family_main: `"Inter", arial, georgia, sans-serif`,
  font_family_th: `"Noto Sans TH", arial, georgia, sans-serif`,
  supports_uppercasing: true,

  font_scale_factor: "10",
  fs_base: "16px",

  /* Font sizes */
  fs_header: `${calcEmFromPx(61)}rem`, // ~61px
  fs_header_sub: `${calcEmFromPx(16)}rem`, // ~16px
  fs_header_type: `${calcEmFromPx(20)}rem`, // ~20px
  fs_cta_small: `${calcEmFromPx(10)}rem`, // ~10px
  fs_ico_key: `${calcEmFromPx(8)}rem`, // ~8px
  // "0.56rem", // ~9px

  // These are in pixels, but we intentionally do not add px
  min_resolution: "408",
  max_resolution_fluid: "1023",

  /* Colors */
  color_bg: colors.bg_dark_primary,
  color_bg_secondary: colors.bg_dark_secondary,
  color_bg_tertiary: colors.bg_dark_tertiary,

  color_heading: colors.primary_3,
  color_text: colors.primary_7,
  color_text_primary: colors.text_primary,
  color_text_secondary: colors.text_secondary,
  color_text_secondary_dimmed: colors.text_secondary_dimmed,
  color_link: colors.dark_lol_blue,
  color_white: colors.default_white,

  color_btn_link_text: colors.button_link_text,
  color_btn_link_text__hover: colors.button_link_text,
  color_btn_link_text__active: colors.button_link_text,

  color_btn_primary_text: colors.text_primary,
  color_btn_primary_rev_text: colors.text_primary_rev,
  color_btn_primary_bg: colors.lol_blue,
  color_btn_primary_rev_bg: colors.primary_9,
  color_btn_primary_bg__hover: colors.lol_blue__hover,
  color_btn_primary_bg__active: colors.lol_blue__active,

  color_btn_secondary_bg: colors.gray_primary,
  color_btn_secondary_bg__hover: colors.gray_primary__hover,
  color_btn_secondary_bg__active: colors.gray_primary__active,

  color_btn_buy_bg: colors.lol_blue,
  color_btn_buy_bg__hover: colors.lol_blue__hover,
  color_btn_buy_bg__active: colors.lol_blue__active,

  color_modal_background: colors.default_white,
  color_modal_btn_container_background: colors.gray_tertiary,
  color_modal_h1_text: colors.text_dark_primary,
  color_modal_p_text: colors.text_tertiary_dimmed,
  color_btn_modal_primary_text: colors.primary_but_modal_text,
  color_btn_modal_primary_bg: colors.primary_but_modal_bg,
  color_btn_modal_primary_text__hover: colors.primary_but_modal_text__hover,
  color_btn_modal_primary_bg__hover: colors.primary_but_modal_bg__hover,
  color_btn_modal_primary_text__active: colors.primary_but_modal_text__active,
  color_btn_modal_primary_bg__active: colors.primary_but_modal_bg__active,

  color_modal_mobile_background: colors.bg_dark_tertiary,
  color_modal_mobile_btn_container_background: colors.bg_dark_secondary,
  color_modal_mobile_h1_text: colors.gray_tertiary,
  color_modal_mobile_p_text: colors.text_tertiary,
  color_btn_mobile_modal_primary_text: colors.primary_mobile_but_modal_text,
  color_btn_mobile_modal_primary_bg: colors.primary_mobile_but_modal_bg,
  color_btn_mobile_modal_primary_text__hover: colors.primary_mobile_but_modal_text__hover,
  color_btn_mobile_modal_primary_bg__hover: colors.primary_mobile_but_modal_bg__hover,
  color_btn_mobile_modal_primary_text__active: colors.primary_mobile_but_modal_text__active,
  color_btn_mobile_modal_primary_bg__active: colors.primary_mobile_but_modal_bg__active,

  color_btn_modal_secondary_text: colors.secondary_but_modal_text,
  color_btn_modal_secondary_bg: colors.secondary_but_modal_bg,
  color_btn_modal_secondary_text__hover: colors.secondary_but_modal_text__hover,
  color_btn_modal_secondary_bg__hover: colors.secondary_but_modal_bg__hover,
  color_btn_modal_secondary_text__active: colors.secondary_but_modal_text__active,
  color_btn_modal_secondary_bg__active: colors.secondary_but_modal_bg__active,

  color_btn_mobile_modal_secondary_text: colors.secondary_mobile_but_modal_text,
  color_btn_mobile_modal_secondary_bg: colors.secondary_mobile_but_modal_bg,
  color_btn_mobile_modal_secondary_text__hover: colors.secondary_mobile_but_modal_text__hover,
  color_btn_mobile_modal_secondary_bg__hover: colors.secondary_mobile_but_modal_bg__hover,
  color_btn_mobile_modal_secondary_text__active: colors.secondary_mobile_but_modal_text__active,
  color_btn_mobile_modal_secondary_bg__active: colors.secondary_mobile_but_modal_bg__active,

  ability_highlight: colors.gray_primary,

  color_highlight: colors.dark_affirmative_green,

  color_success_bg: colors.wr_yellow,

  radius_avatar: "160px",
  radius_play_button: `${calcEmFromPx(18)}rem`,
  radius_video_player: "8px",
  avatar_size: "120px",
  avatar_size_mobile: "200px",
  avatar_spacing: "24px auto",

  sidebar_width_mobile: "408px",
  sidebar_width_desktop: "566px",
  sidebar_margin: `${calcEmFromPx(16)}rem`,
  sidebar_margin_desktop: `${calcEmFromPx(64)}rem`,

  content_spacing: `${calcEmFromPx(48)}rem`,

  // Riotbar specific
  riotbar_height: "80px",

  mobile_header_height: "612px",
};
